// vim: set ts=2 sts=2 sw=2 et:
//
// Per-PC identity for the sync feature. The shared OpenLifter link reuses PC 1's session token, so
// the session can NOT identify a PC. Instead each browser gets a stable random deviceId, plus a
// declared "my tarima" (day/platform) used to decide what Sincronizar merges from others.

const DEVICE_ID_KEY = "wrpf-openlifter-device-id";
const MY_TARIMA_KEY = "wrpf-openlifter-my-tarima";

export type MyTarima = {
  day: number;
  platform: number;
  label: string;
};

const randomId = (): string => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `dev-${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
};

/** Stable random id for THIS browser/PC (persisted in localStorage). */
export function getDeviceId(): string {
  if (typeof window === "undefined") return "ssr";
  const existing = window.localStorage.getItem(DEVICE_ID_KEY);
  if (existing && existing.length > 0) return existing;
  const id = randomId();
  window.localStorage.setItem(DEVICE_ID_KEY, id);
  return id;
}

export function defaultMyTarima(day: number, platform: number): MyTarima {
  return { day, platform, label: `Tarima ${platform}` };
}

export function getMyTarima(fallback: MyTarima): MyTarima {
  if (typeof window === "undefined") return fallback;
  try {
    const raw = window.localStorage.getItem(MY_TARIMA_KEY);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw) as Partial<MyTarima>;
    if (typeof parsed.day === "number" && typeof parsed.platform === "number") {
      return {
        day: parsed.day,
        platform: parsed.platform,
        label:
          typeof parsed.label === "string" && parsed.label.trim().length > 0
            ? parsed.label
            : `Tarima ${parsed.platform}`,
      };
    }
  } catch {
    /* ignore */
  }
  return fallback;
}

export function saveMyTarima(tarima: MyTarima): void {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(MY_TARIMA_KEY, JSON.stringify(tarima));
}
